import React from 'react';

interface StoryProgressBarProps {
  total: number;
  activeIndex: number;
  fillRefs: React.RefObject<HTMLDivElement | null>[];
}

const MAX_VISIBLE = 15;

const StoryProgressBar: React.FC<StoryProgressBarProps> = ({ total, activeIndex, fillRefs }) => {
  const count = Math.min(total, MAX_VISIBLE);

  return (
    <div
      className="absolute left-3 right-3 z-30 flex gap-1 pointer-events-none"
      style={{ top: 'calc(env(safe-area-inset-top) + 8px)' }}
    >
      {Array.from({ length: count }).map((_, i) => (
        <div
          key={i}
          className="flex-1 h-[3px] bg-white/30 rounded-full overflow-hidden"
        >
          <div
            ref={fillRefs[i] as React.RefObject<HTMLDivElement>}
            className="h-full bg-white rounded-full"
            style={{ width: i < activeIndex ? '100%' : '0%' }}
          />
        </div>
      ))}
    </div>
  );
};

export default StoryProgressBar;
